import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nModule, UrlModule } from '@spartacus/core';
import { GenApplicableProductsComponent } from './applicable-products.component';
import { MediaModule, PaginationModule } from '@spartacus/storefront';
import { RouterModule } from '@angular/router';
import { GenPaginationComponent } from 'src/app/generac/shared/components/pagination/pagination.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    PaginationModule,
    MediaModule,
    UrlModule,
    RouterModule,
    GenPaginationComponent,
  ],
  declarations: [GenApplicableProductsComponent],
  exports: [GenApplicableProductsComponent],
})
export class GenApplicableProductsModule {}
